import SIOdefaults from './config';
import clearQueue from './clearQueue';
import localforage from 'localforage';

var mongoObjectId = function () {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
};

var framework = {
    createStore: function (name) {
        return localforage.createInstance({
            name: name,
            driver: localforage.INDEXEDDB
        });
    },
    getItem: function (store, key) {
        return store.getItem(key);
    },
    setItem: function (store, key, value) {
        return store.setItem(key, value);
    },
    clearStore: function (store) {
        return store.clear();
    },
    iterate: function (store, callback) {
        return store.iterate(callback);
    },
    removeItem: function (store, key) {
        return store.removeItem(key);
    },
    length: function (store) {
        return store.length();
    },
    keys: function (store) {
        return store.keys();
    }
};

var SIOdal = (function (storeNames) {

	"use strict";

    var stores = {};

	var dal = {
        createStore: function (storeName) {

            stores[storeName] = framework.createStore(storeName);

            return stores[storeName];

        },
        getStores: function () {
            return stores;
        },
        deleteStore: function () {

        },
        clearStore: function (storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.clearStore(stores[storeName]);
        },
        getStoreLength: function (storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.length(stores[storeName]);
        },
        getStoreKeys: function (storeName) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.keys(stores[storeName]);
        },
        clearAllStores: function () {
            var promises = [];

            for (var store in stores) {
                promises.push(function () {
                    return framework.clearStore(stores[store])
                });
            }

            return clearQueue(promises);

        },
        deleteAllStores: function () {

        },
        getItem: function (storeName, key) {

            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.getItem(stores[storeName], key);
        },
        setItem: function (storeName, key, value) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.setItem(stores[storeName], key, value);
        },
        iterate: function (storeName, callback) {
            if (typeof stores[storeName] == "undefined") {
                dal.createStore(storeName);
            }

            return framework.iterate(stores[storeName], callback);
        },
        removeItem: function(storeName, key) {
            return framework.removeItem(stores[storeName], key);
        },
        cloneItem: function (storeNameFrom, storeNameTo, key) {
            
            return framework.getItem(stores[storeNameFrom], key).then(function (result) {
                return framework.setItem(stores[storeNameTo], key, result);
            });
        },
        moveItem: function () {

        },
        init: function (storeNames) {
            storeNames.forEach (function (name) {
                dal.createStore(name);
            });
        }
        
    };

    dal.init(storeNames);

    return dal;

})(SIOdefaults.stores);

window.dal = SIOdal;


export default SIOdal;

export {
    mongoObjectId
}


// WEBPACK FOOTER //
// ./src/js/Sync/dal.js